import React from 'react';

import { FieldTitle } from '../../common';

const PropertyHoldings = ({ label, internalTitle, formId, required, placeholder, ...props }) => {
  const contentArticleFormId = `content_article_form-${props.contentArticleFormId}`;
  const forId = `${contentArticleFormId}-${FieldTitle.titleFor(internalTitle, formId)}`;

  return (
    <div>
      <div className="clearfix"></div>

      <div className="hint">
        Wertpapiername, WKN oder ISIN
        <span className="curr-val-text">Aktueller Wert</span>
      </div>

      <div className={`property-holdings ${internalTitle}`}>
        {[...Array(3)].map((_, i) => (
          <div key={`propertyholding-${i}`}>
            <input
              type="hidden"
              name={`${internalTitle}[${i}][description]`}
              id={`${forId}_${i}_description`}
              className="description"
            />
            <input
              type="hidden"
              name={`${internalTitle}[${i}][wkn]`}
              id={`${forId}_${i}_wkn`}
              className="wkn"
            />
            <input
              type="hidden"
              name={`${internalTitle}[${i}][isin]`}
              id={`${forId}_${i}_isin`}
              className="isin"
            />
            <input
              type="text"
              name={`${internalTitle}[${i}][autocomplete]`}
              id={`${forId}_${i}_autocomplete`}
              required={required}
              placeholder={required && !label.length ? `${placeholder} *` : placeholder}
              className="autocomplete ui-autocomplete-input"
              tabIndex="20"
              data-parsley-autocomplete-value="true"
              data-parsley-validate-if-empty="true"
              autoComplete="off"
            />
            <input
              type="text"
              name={`${internalTitle}[${i}][value]`}
              id={`${forId}_${i}_value`}
              required={required}
              placeholder="Betrag €"
              className="value"
              tabIndex="20"
              data-parsley-autocomplete-value="true"
              data-parsley-validate-if-empty="true"
            />
            <i className="fa fa-times-circle"></i>
          </div>
        ))}
      </div>

      <div className="property-buttons clearfix no-margin-bottom">
        <a className="button add margin-bottom-xxs">+ Wertpapier hinzufügen</a>
      </div>
    </div>
  );
};

PropertyHoldings.propTypes = {
  label: React.PropTypes.string,
  internalTitle: React.PropTypes.string,
  formId: React.PropTypes.number,
  required: React.PropTypes.bool,
  placeholder: React.PropTypes.string,
  contentArticleFormId: React.PropTypes.number
};

export default PropertyHoldings;



// WEBPACK FOOTER //
// ./components/forms/depotCheck/propertyHoldings.js